var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.333 64.6329V69.9995C128.326 82.5787 124.253 94.8185 116.721 104.894C109.189 114.969 98.6026 122.339 86.5397 125.906C74.4768 129.472 61.5841 129.044 49.7845 124.685C37.9849 120.325 27.9106 112.268 21.064 101.716C14.2175 91.1631 10.9655 78.6799 11.7932 66.128C12.6209 53.5762 17.4838 41.6281 25.6567 32.0658C33.8296 22.5035 44.8747 15.8393 57.1445 13.0671C69.4144 10.2948 82.2516 11.5632 93.7418 16.6829",
    stroke: "#5CCA95",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.333 23.333L70 81.7247L52.5 64.2247",
    stroke: "#5CCA95",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.575d364a07187836515fd9c431845112.svg";
export { ForwardRef as ReactComponent };